import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { NavState } from "../slices/nav.slice";

const selectNavReducer = (state:RootState): NavState => state.nav;

export const selectNav = createSelector(
    [selectNavReducer],
    (navSlice) => navSlice.isNavOpen,
)